/**
 * Single source of truth for themes.
 *
 * Colours themselves live in `src/index.css` as CSS variables and are never
 * written as hex, rgb or a Tailwind colour literal inside a component. This file
 * only declares which themes exist.
 */
export const THEMES = ['light', 'dark', 'clean'] as const;

export type Theme = (typeof THEMES)[number];

export const themeConfig = {
  themes: [...THEMES],
  /** next-themes toggles this attribute on <html>; the Tailwind config is darkMode:'class'. */
  attribute: 'class' as const,
  storageKey: 'agencias.theme',
} as const;
